import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));

class FuseToggleDropdown extends Component {
  state = {
    isCollapsed: this.props.openExpanded,
  };

  handleClick = e => {
    this.setState({ isCollapsed: !this.state.isCollapsed });
  };

  render() {
    const { current } = this.state;
    return (
      <Dropdown drop={this.props.dropDirection} title={this.props.title}>
        <Dropdown.Toggle as={CustomToggle}><i className={this.props.iconClasses}/></Dropdown.Toggle>
        <Dropdown.Menu className="fuse-overview-table-toggle-drop" align="end">
            {this.props.children}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

FuseToggleDropdown.propTypes = {
    iconClasses: PropTypes.string.isRequired,
    dropDirection: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired //Currently expects anything that can go inside Dropdown.Menu. (Eg <Dropdown.Item/> nodes.)
  };

export default FuseToggleDropdown;

